module.exports = __webpack_public_path__ + "img/active_product2.a5a2251.png";